export default "__VITE_ASSET__CysgLwT9__"